import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { getDefaultRoute } from '@src/lib/constants';
import { ReduxProps } from '@src/redux/type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PublicRoute = ({ component: Component }: any) => {
  const { isUserAuthenticated, userData } = useSelector((state: ReduxProps) => state?.loginReducer?.loginState);
  const path = userData?.org?.org_id ? `/${userData?.org?.org_id}` : '';

  return !isUserAuthenticated ? <Component /> : <Navigate to={path + getDefaultRoute(userData)} replace />;
};

export default PublicRoute;
